import Divider from "@mui/material/Divider"
import Typography from "@mui/material/Typography"

export default function PublicPageHeader({
  title
}: {
  title: string
  caption: string
}) {
  return (
    <>
      <Typography variant="h6" fontWeight={"bold"}>
        {title}
      </Typography>
      {/* <Typography sx={{ color: "gray" }}>{caption}</Typography> */}
      <Divider />
    </>
  )
}
